import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    redirect: { name: "site" },
  },
  {
    path: "/site",
    name: "site",
    component: () => import(/* webpackChunkName: "site" */ "../views/Site.vue"),
  },
  {
    path: "/sitesuccess",
    name: "sitesuccess",
    component: () =>
      import(/* webpackChunkName: "site" */ "../views/SiteSuccess.vue"),
  },
  {
    path: "/product",
    name: "product",
    component: () =>
      import(/* webpackChunkName: "product" */ "../views/Product.vue"),
  },
  {
    path: "/productsuccess",
    name: "productsuccess",
    component: () =>
      import(/* webpackChunkName: "product" */ "../views/ProductSuccess.vue"),
  },
  {
    path: "/reSubscribe",
    name: "reSubscribe",
    component: () =>
      import(/* webpackChunkName: "product" */ "../views/ReSubscribe.vue"),
  },
  // {
  //   path: "/newResubscribe",
  //   name: "newResubscribe",
  //   component: () =>
  //     import(/* webpackChunkName: "product" */ "../views/newReSubscribe.vue"),
  // },
  {
    path: "/newResubscribe",
    name: "newResubscribeV3",
    component: () =>
      import(/* webpackChunkName: "product" */ "../views/newReSubscribeV3.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
